module.exports = __webpack_public_path__ + "static/media/right-icon.9a9e8159.svg";